export default __webpack_public_path__ + "static/media/request-dashboard-access-illustration.caa3f83f.png";